import React, { useEffect, useState } from "react";

import { Theme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import Pagination from "components/Pagination";
import ExamHistoryItem from "components/VetExams/ExamHistoryItem";
import Loader from "components/Loader";
import { EVariantExamsHistory } from "components/VetExams/ExamHistoryItem/helper";
import PaperCarousel from "components/PaperCarousel";
import useStyles from "./styles";

interface IProps {
  exams: racehorse360.IHorseExam[];
  isExamsLoading: boolean;
  onLoad?: (items) => void;
}

const PastExams = (props: IProps) => {
  const { exams, isExamsLoading, onLoad } = props;
  const classes = useStyles();
  const matchesDownSm = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  const [pageNumber, setPageNumber] = useState<number>(1);
  const [slideNumber, setSlideNumber] = useState<number>(0);

  useEffect(() => {
    onLoad && onLoad(exams);
  }, [exams]);

  const handleChangeSlide = (index: number) => {
    if (exams.length !== 1) {
      setSlideNumber(index);
    }
  };

  const renderNoPastExams = () => {
    return <div className={classes.noExams}>No Past Exams</div>;
  };

  const renderCarouselItem = item => {
    return (
      <ExamHistoryItem
        className={classes.mobileExamHistoryItem}
        exam={item}
        variant={EVariantExamsHistory.DETAILS}
      />
    );
  };

  const renderDesktopContent = () => {
    if (!exams.length) return renderNoPastExams();

    return isExamsLoading ? (
      <Loader />
    ) : (
      <ExamHistoryItem
        exam={exams[pageNumber - 1]}
        variant={EVariantExamsHistory.DETAILS}
      />
    );
  };

  const renderMobilePastExams = () => {
    const currentPage = exams.length ? slideNumber + 1 : 0;
    const title = exams.length ? "Past Exams" : "No Past Exams";
    const slideNumberInfo = exams.length
      ? `Showing ${currentPage} of ${exams.length}`
      : "";

    return (
      <div>
        <div className={classes.mobileHeader}>
          <span className={classes.mobileTitle}>{title}</span>
          <span>{slideNumberInfo}</span>
        </div>
        {Boolean(exams.length) && (
          <PaperCarousel
            className={classes.carousel}
            items={exams}
            onSlideChange={handleChangeSlide}
            itemRenderer={renderCarouselItem}
          />
        )}
      </div>
    );
  };

  if (matchesDownSm) return renderMobilePastExams();

  return (
    <div className={classes.pastExams}>
      <div>{renderDesktopContent()}</div>
      <div className={classes.footer}>
        <Pagination
          totalCount={exams.length}
          onPageChange={setPageNumber}
          pageSize={1}
          pageNumber={pageNumber}
        />
      </div>
    </div>
  );
};

export default PastExams;
